import styled, { css } from 'styled-components';
import { withQuery, select } from '@panel/commons/core/themev2';
import radioButtom from '@panel/commons/assets/icons/radio_button.svg';
import radioButtomChecked from '@panel/commons/assets/icons/radio_button_checked.svg';
import AlertCircleBlue from '@panel/commons/assets/icons/AlertCircleBlue.svg';
import { getColor } from '@panel/commons/core/themev3';

const Container = styled.div`
  max-width: 572px;
  margin-bottom: 10px;
`;

const ContainerMap = styled.div`
  margin-top: 20px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 4px;
  ${({ isMobile }) =>
    !isMobile &&
    css`
      max-width: 48%;
    `}
`;

const InputWrapperCP = styled(InputWrapper)`
  max-width: 48%;
`;

const SwitchLocationLabel = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

const Title = styled.h2`
  font-size: 20px;
  white-space: normal;
  ${withQuery.sm.down()} {
    font-size: 18px;
  }
  ${({ isMobile }) =>
    isMobile &&
    css`
      margin-top: 40px;
      line-height: 10px;
    `}
`;

const TitleWrapper = styled.div`
  ${withQuery.lg.down()} {
    /* padding: 0 16px; */
  }
`;
const Subtitle = styled.p`
  margin: 5px 0;
  color: ${select('darkGray')};
  white-space: normal;
`;

const MapNotice = styled.div`
  font-weight: 600;
  ${withQuery.lg.down()} {
    padding: 0 16px;
  }
`;

const InputCommonStyles = css`
  font-size: 1.4rem;
  height: 48px;
  padding: 0px 12px;
  border-radius: 8px;
  outline: none;
  font-family: 'Hind';
  &:focus {
    border-color: ${getColor('primary')};
  }
`;

const StyledInput = styled.input`
  ${InputCommonStyles}
  width: 100%;
  border: solid 1px ${select('midDarkGray')};
  :disabled {
    background-color: ${select('lightGray')};
    border: none;
    color: ${select('midLightGray')};
    ::placeholder {
      color: ${select('midLightGray')};
    }
  }
`;

const InputTitle = styled.p`
  margin: ${({ margin }) => margin || '0px 0px 5px'};
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${select('midNeutralGray')};
    `}
`;

const Address = styled.input`
  ${InputCommonStyles}
  max-width: 608px;
  width: 100%;
  border: solid 1px ${select('midDarkGray')};
  :disabled {
    background-color: ${select('lightGray')};
    border: none;
    color: ${select('midLightGray')};
    ::placeholder {
      color: ${select('midLightGray')};
    }
  }
  ${({ hasError }) => {
    return (
      hasError &&
      css`
        border-color: ${select('redNoTRecommended')};
      `
    );
  }}
  ${({ isOnCEPView }) => {
    return (
      !isOnCEPView &&
      css`
        margin-bottom: 12px;
      `
    );
  }}
`;

const InputCEP = styled.input`
  ${InputCommonStyles}
  /* max-width: 480px; */
  width: 83%;
  border: solid 1px ${select('midDarkGray')};
  -moz-appearance: textfield;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${({ hasError }) =>
    hasError &&
    css`
      border-color: ${select('redNoTRecommended')};
    `}

  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 100%;
    `}
`;

const SearchButton = styled.button`
  width: 17%;
  height: 48px;
  border-radius: 8px;
  border: 1px solid ${getColor('primary')};
  cursor: pointer;
  margin-left: 8px;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  color: ${select('black')};
  :hover {
    background-color: ${select('creamLightOrange')};
  }
  :disabled {
    background: ${select('lightGray')};
    border: 1px solid ${select('lightGray')};
  }
  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 100%;
      margin-left: 0px;
      margin-top: 8px;
    `}
`;

const CepContainer = styled.div`
  margin-top: 22px;
  margin-bottom: 12px;
  position: relative;
  ${withQuery.xs.down()} {
    display: flex;
    flex-direction: column;
  }
`;

const PlacesSuggestions = styled.div`
  padding: 8px 0;
  /* width: 608px; */
  border-radius: 8px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px ${select('middleGray')};
  background-color: ${select('white')};
  font-size: 1.4rem;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
  .suggestion-item {
    opacity: 0.8;
    line-height: 32px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    &.active {
      background: ${select('lightGray')};
    }
  }
`;

const AddressContainer = styled.div`
  width: 100%;
  position: relative;
`;

const ComplementContainer = styled.div`
  width: 48%;
  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 100%;
      margin-top: 18px;
    `}
`;

const InputComplement = styled.input`
  ${InputCommonStyles}
  max-width: 608px;
  width: 100%;
  border: solid 1px ${select('midDarkGray')};
  -moz-appearance: textfield;
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${withQuery.lg.down()} {
    width: 100%;
  }
`;

const AddressFieldsContainerBR = styled.div`
  display: flex;
  margin-top: 24px;
  width: 48%;
  ${({ isOnCEPView }) =>
    !isOnCEPView
      ? css`
          width: 100%;
        `
      : css`
          margin-top: 4px;
        `}
  ${withQuery.lg.down()} {
    flex-direction: column;
  }
  ${({ isMobile, isOnCEPView }) =>
    isMobile &&
    isOnCEPView &&
    css`
      width: 100%;
    `}
`;

const AddressFieldsContainer = styled.div`
  display: flex;
  max-width: 608px;
  ${withQuery.lg.down()} {
    flex-direction: column;
  }
`;

const LocationCombosContainer = styled.div`
  display: flex;
  max-width: 608px;
  gap: 14px 4%;
  flex-wrap: wrap;
  ${withQuery.lg.down()} {
    flex-wrap: wrap;
  }
  ${({ isMobile }) =>
    isMobile
      ? css`
          flex-direction: column;
          gap: 0px;
        `
      : css`
          margin-bottom: 14px;
        `}
`;

const LocationSelectCombo = styled.select`
  ${InputCommonStyles}
  border: solid 1px ${select('midDarkGray')};
  width: 100%;
  background-color: ${select('white')};
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 30px;
  white-space: nowrap;
  appearance: none;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    border-color: ${getColor('primary')};
    cursor: pointer;
  }
  &:disabled {
    color: ${select('midNeutralGray')};
    background-color: ${select('neutralGray')};
    border: 1px solid ${select('midNeutralGray')};
    cursor:default;
  }
  ${({ errors }) =>
    errors &&
    css`
      border-color: ${select('redNoTRecommended')};
    `}
`;

const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  top: -32px;
  right: 16px;
  float: right;
  pointer-events: none;
`;

const SingleCombo = styled.div`
  flex-direction: column;
  flex: 1;
  position: relative;
  min-width: 48%;
  ${withQuery.lg.down()} {
    width: 100%;
  }
  ${({ isMobile }) =>
    isMobile
      ? css`
          margin-bottom: 18px;
        `
      : css`
          max-width: 48%;
        `}
`;

const ErrorMessage = styled.span`
  color: ${select('negative')};
  display: inherit;
  position: absolute;
  bottom: ${({ isOnCEPView }) => (isOnCEPView ? '-20px' : '-8px')};
  left: 0;
  font-size: 12px;
`;

const InfoMessage = styled.span`
  color: ${select('neutralDarkGrayII')};
  display: inherit;
  font-size: 12px;
  max-width: 90%;
  white-space: break-spaces;
`;

const MapAddress = styled.div`
  display: flex;
  align-items: center;
  color: ${select('darkGray')};
  white-space: normal;
  > span:first-child {
    color: ${select('darkGray')};
  }
  svg {
    vertical-align: bottom;
    margin-right: 8px;
  }
  ${withQuery.lg.down()} {
    padding: 0 16px;
  }
`;
const MapWrapper = styled.div`
  width: 100%;
  height: 292px;
  margin-bottom: 20px;
  background: #eaeaea;
  display: flex;
  justify-content: center;
  align-items: center;
  ${withQuery.lg.down()} {
    overflow: hidden;
    height: 292px;
  }
  .gm-style .gm-style-iw-c {
    border-radius: 8px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.09);
    border: 1px solid ${select('neutralMediumGray')};
    padding: 8px !important;
    > button {
      display: none !important;
    }
  }
  .gm-style-iw-tc::after {
    display: none;
  }
  .gm-style-iw-d {
    overflow: unset !important;
    padding: 0 !important;
  }
`;

const InfoWindowText = styled.p`
  font-family: Hind;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  width: 140px;
  white-space: break-spaces;
  ${withQuery.xs.down()} {
    font-size: 9px;
  }
`;

const CheckboxContainer = styled.div`
  width: fit-content;
  height: 22px;
  margin-bottom: 16px;
  > label {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    > img {
      margin-right: 8px;
      margin-bottom: 2px;
    }
  }
  ${withQuery.lg.down()} {
    padding: 0 16px;
  }
`;

const VisibilityOptionsAddressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  margin-top: 16px;
  ${withQuery.lg.down()} {
    /* flex-direction: column; */
  }
`;

const VisibilityOptionsContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  position: relative;
  & div.exact {
    margin-right: 18px;
  }
  ${withQuery.lg.down()} {
    justify-content: flex-start;
    padding: 0 16px;
    margin-bottom: 12px;
  }
`;

const VisibilityOptions = styled.div`
  height: auto;
  margin: 0px;
  position: relative;
  input {
    display: none;
  }
  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    > span {
      display: inline-block;
      padding: 2px 7px;
    }
  }
  label::before {
    display: inline-block;
  }
  input + label::before {
    content: '';
    width: 16px;
    height: 16px;
    background-image: url(${radioButtom});
  }
  input:checked + label::before {
    content: '';
    background-image: url(${radioButtomChecked});
  }
`;

const InfoBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  padding: 12px;
  border: 1px solid ${select('midLightGray')};
  border-left: 4px solid ${select('blue')};
  border-radius: 4px;
  white-space: normal;
  &:before {
    content: '';
    vertical-align: text-top;
    width: 16px;
    height: 16px;
    margin-right: 9px;
    position: absolute;
    background-image: url(${AlertCircleBlue});
    background-repeat: no-repeat;
    ${withQuery.xs.down()} {
      align-items: baseline;
      top: 16px;
    }
  }
  p {
    margin-left: 10px;
  }
  ${withQuery.xs.down()} {
    margin-bottom: 24px;
  }
  ${withQuery.lg.down()} {
    margin: 0 16px;
    width: auto;
  }
`;

const CloseButton = styled.div`
  cursor: pointer;
  width: 16px;
  height: 100%;
  margin-left: 4px;
  margin-right: 4px;
`;

const InfoWindowContainer = styled.div`
  display: flex;
`;

export {
  InfoWindowContainer,
  Container,
  ContainerMap,
  Title,
  Subtitle,
  InputTitle,
  Address,
  PlacesSuggestions,
  AddressContainer,
  InputComplement,
  StyledInput,
  AddressFieldsContainer,
  ComplementContainer,
  LocationCombosContainer,
  LocationSelectCombo,
  IconWrapper,
  SingleCombo,
  ErrorMessage,
  MapAddress,
  MapWrapper,
  InfoWindowText,
  CheckboxContainer,
  VisibilityOptionsAddressWrapper,
  VisibilityOptionsContainer,
  VisibilityOptions,
  InfoBox,
  TitleWrapper,
  InputCEP,
  SearchButton,
  CepContainer,
  MapNotice,
  SwitchLocationLabel,
  InputWrapper,
  InfoMessage,
  CloseButton,
  AddressFieldsContainerBR
};
